export default class HttpError extends Error {
  name: string;
  url: string;
  method: string;
  status: number;
  response: Response;

  constructor(response: Response, request: Request) {
    super(response.statusText);
    this.name = 'HttpError';
    this.message = `${response.status} ${request.method} ${
      new URL(request.url).pathname
    }`;
    this.url = request.url;
    this.method = request.method;
    this.status = response.status;
    this.response = response;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpError);
    }
  }
}
